import configuration from './configuration'

const { PAYPER_WEB_BASE_ROUTE, PAYPER_MAGIC_BROWSE_ROUTE } =
  configuration as Record<string, string>

const ACCESS_PARAMS = {
  USER_LICENCE_TOKEN: 'ul',
  REDIRECT_URI: 'redirect_uri',
}

export const URL_PARAM_KEY = 'url'

export const handleRedirectOnUnauth = (): void => {
  const currentSearchParams = new URLSearchParams(window.location.search)
  const urlParam = currentSearchParams.get(URL_PARAM_KEY)

  const redirectUriParamValue = PAYPER_MAGIC_BROWSE_ROUTE.concat(
    urlParam ? `?${URL_PARAM_KEY}=${encodeURIComponent(urlParam)}` : '',
  )
  const newUrl = `${PAYPER_WEB_BASE_ROUTE}/access?${ACCESS_PARAMS.REDIRECT_URI}=${redirectUriParamValue}`

  window.location.href = newUrl
}

export const handleRedirectOnEndOfService = () => {
  window.location.href = `${PAYPER_WEB_BASE_ROUTE}/end-of-service`
}

export const handleRedirectOnMediaAccessDenied = () => {
  window.location.href = `${PAYPER_WEB_BASE_ROUTE}/media-access-denied`
}
